import { getAuthAxios } from "@artprov/design-system";

const pathsSolicitud = {
  getAll: "rendicion",
  getById: "rendicion/:id",
  detail: "detalle",
  getAutorizantesEstado: (id) => `rendicion/${id}/estado`
};

// TODO: Quizas deberia llamar a getSolicitudes en solicitudesServices.
export const getSolicitudes = async () => {
  return await getAuthAxios("default").get(pathsSolicitud.getAll);
};

/*
Example post request
*/
export const createSolicitud = async (solicitud) => {
  const bodyFormData = new FormData();
  bodyFormData.append("solicitud", solicitud);
  await getAuthAxios("default").post("pathsSolicitud.create");
};

export const getDetalleDeRendiciones = async (id) => {
  return await getAuthAxios("default").get(`${pathsSolicitud.getAll}/${id}/${pathsSolicitud.detail}`);
};

export const getEstadoAutorizantes = async (id) => {
  try {
    const { data } = await getAuthAxios("default").get(pathsSolicitud.getAutorizantesEstado(id))

    return data
  } catch (error) {
    return []
  }
}